<template>
    <div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">设备入口地址列表</span>
            <el-button style="float: right;margin-left:10px;" type="success" @click="btnAddEntryAddr">新增入口</el-button>
        </div>
        <div>
            <el-table
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="deviceData"
                border
                fit
                height="520"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    header-align="center"
                    width="80"
                    label="编号">
                </el-table-column>
               <el-table-column
                    prop="name"
                    header-align="center"
                    width="130"
                    label="公众号名称">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    header-align="center"
                    min-width="180"
                    label="创建时间">
                </el-table-column>
                <el-table-column
                    prop="statusName"
                    header-align="center"
                    min-width="100"
                    label="状态">
                </el-table-column>
                <el-table-column
                    prop="deviceNum"
                    header-align="center"
                    min-width="100"
                    label="关联设备">
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    min-width="200"
                    label="操作">
                    <template scope="scope">
                        <el-button type="text" size="small" @click="btnSeeDeviceList(scope.row)" style="color:#666666;">查看设备</el-button>
                        <el-button type="text" size="small" v-if="scope.row.status == 0"
                          @click="btnStopEntryAddress(scope.row.id, scope.row.appid, 1)" style="color:#FF9090;">启用入口</el-button>
                        <el-button type="text" size="small" v-if="scope.row.status == 1"
                          @click="btnStopEntryAddress(scope.row.id, scope.row.appid, 0)" style="color:#FF9090;">停用入口</el-button>
                        <el-button type="text" size="small" @click="btnEditEntryAddr(scope.row)" style="color:#81B7F8;">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="table_pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal">
            </el-pagination>
        </div>
      </el-card>
      <!-- <po-add-pay :add-show="addPicShow" @closeAddPay="closeAddPic"></po-add-pay> -->
    </div>
</template>

<script>
import $axios from '../../https/config'
// import poNewAddPay from '@/page/adMgr/adNewAddPay'

export default {
  data () {
    return {
      pageSize: 10,
      pageNo: 1,
      table_loading: false,
      deviceData: [],
      pageTotal: 0,
      addPicShow: false,
      curType: 0,
      multipleSelection: '',
      xxxx: ''
    }
  },
  created: function () {
    this.pageNo = 1
    this.queryDeviceList()
  },
  methods: {
    btnAddEntryAddr () {
      this.$router.push({path: '../adMgr/addEntryAddress', query: {'type': 'add'}})
    },
    btnEditEntryAddr (editEntryAddr) {
      this.$router.push({
        path: '../adMgr/addEntryAddress',
        query: {'type': 'edit', 'id': editEntryAddr.id, 'appid': editEntryAddr.appid, 'name': editEntryAddr.name}
      })
    },
    btnSeeDeviceList (item) {
      this.$router.push({path: '../adMgr/entryQrcodeDeviceList', query: {'id': item.appid}})
    },
    queryDeviceList () {
      var params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.table_loading = true
      this.deviceData = []
      var _this = this
      $axios.get('/para/queryEntranceQrCodeList', params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          var resData = []
          if (res.resultData && res.resultData.list.length > 0) {
            _this.pageTotal = res.resultData.count
            for (var i = 0; i < res.resultData.list.length; i++) {
              var itemData = res.resultData.list[i]
              var item = {
                id: itemData.id,
                appid: itemData.appid,
                name: itemData.nickname,
                createTime: itemData.createTime,
                status: itemData.status,
                statusName: Number(itemData.status) === 0 ? '已停用' : '已启用',
                deviceNum: itemData.count
              }
              resData.push(item)
            }
            _this.deviceData = resData
            _this.pageTotal = res.resultData.count
          }
        } else {
        }
        _this.table_loading = false
      }, function () {})
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDeviceList()
    },
    popNewAddPic (row) {
      this.addPicShow = true
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.queryDeviceList()
    },
    closeAddPic () {
      this.addPicShow = false
      this.pageNo = 1
      this.queryDeviceList()
    },
    btnStopEntryAddress (tId, tAppid, tStatus) {
      var _this = this
      var params = {
        appid: tAppid,
        status: tStatus
      }
      var title1 = '是否停用该入口地址：'
      var title2 = '确认停用'
      var msg1 = '停用入口地址成功'
      var msg2 = '停用入口地址失败'
      if (tStatus === 1) {
        title1 = '是否启用该入口地址：'
        title2 = '确认启用'
        msg1 = '启用入口地址成功'
        msg2 = '启用入口地址失败'
      }
      _this.$confirm(title1 + tId, title2, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        $axios.get('/para/forbiddenParamQrcode', params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            _this.$message({
              type: 'success',
              message: msg1
            })
            _this.queryDeviceList()
          } else {
            _this.$message({
              type: 'error',
              message: msg2 + res.errorMessage
            })
          }
        }, function () {
          _this.$message({
            type: 'error',
            message: msg2
          })
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    }
  },
  components: {
    // 'po-add-pay': poNewAddPay
  }
}
</script>

<style>
    .table_pagination {
      text-align: right;
      margin-top: 10px; 
    }
</style>


// WEBPACK FOOTER //
// src/page/adMgr/deviceEntryAddress.vue